import { addApplicableSlab } from "../../../../../stateManagement/actions/manageCouponActions"
import store from "../../../../../stateManagement/store"
import { APPLICABLE_SLABS_INPUTS_types } from "../../../types"
import { APPLICABLE_SLABS_INPUTS, COUPON_TYPE_OPTIONS_VALUE, INVALID_RANGE_OVERLAPPING, INVALID_SLAB_FIELD, VALID, labelMappings, getApplicableSlabsInputs } from "../../../utils/utils"


/**
 * Validate single slab in applicable slab
 * @param fieldValues 
 * @param currentSlabValues 
 * @param fieldsToCheck 
 * @param errors 
 * @param submitValidation 
 * @returns 
 */
export const validateSingleSlab: any = (fieldValues: any , currentSlabValues:any , fieldsToCheck:Record<string,boolean>,errors:any ,submitValidation?:boolean,slabUnit?:"Qty" | "Value") => {
    // this function will check if the input fields are valid    
    let newErrors: any = { ...errors }

    if ( isSlabFieldRequired('start-range') && (fieldsToCheck.hasOwnProperty("start-range") && ("start-range" in fieldValues || submitValidation))){
        newErrors["start-range"] = fieldValues["start-range"] ? fieldValues["start-range"] >=0 ? "":"Start Range should be greater than zero" : "This field is required."
    }
        
    if ( isSlabFieldRequired('end-range') && (fieldsToCheck.hasOwnProperty("end-range") && ("end-range" in fieldValues || submitValidation)))
        newErrors["end-range"] = fieldValues["end-range"]?fieldValues["end-range"] >=0 ? "":"End Range should be greater than zero" : "This field is required."
        
    if ( isSlabFieldRequired('discount-offered') && (fieldsToCheck.hasOwnProperty("discount-offered") && ("discount-offered" in fieldValues || submitValidation))){
        newErrors["discount-offered"] = fieldValues["discount-offered"]?fieldValues["discount-offered"] >=0 ? "":"Discount Offered should be greater than zero" : "This field is required."
    }
    
    if ( isSlabFieldRequired('final-order-value') && (fieldsToCheck.hasOwnProperty("final-order-value") && ("final-order-value" in fieldValues || submitValidation)))
        newErrors["final-order-value"] = fieldValues["final-order-value"]?fieldValues["final-order-value"] >=0 ? "":"Final Order Value should be greater than zero" : "This field is required."
    
    if ( isSlabFieldRequired('coupon-description') && (fieldsToCheck.hasOwnProperty("coupon-description") && ("coupon-description" in fieldValues || submitValidation)))
        newErrors["coupon-description"] = fieldValues["coupon-description"]?fieldValues["coupon-description"]?.trim().length > 0? "":"Final Order Value should be greater than zero" : "This field is required."


    if("start-range" in fieldValues && currentSlabValues["end-range"]){
        newErrors["start-range"] = Number(fieldValues["start-range"]) <= Number(currentSlabValues["end-range"]) ? "" : "Start Range should be less than or equal to End Range"
        newErrors["end-range"] = Number(currentSlabValues["end-range"]) >= Number(fieldValues["start-range"]) ? "" : "End Range should be greater than or equal to Start Range"
        
    }
    if("end-range" in fieldValues && currentSlabValues["start-range"]){
        newErrors["end-range"] = Number(fieldValues["end-range"]) >= Number(currentSlabValues["start-range"]) ? "" : "End Range should be greater than or equal to Start Range"
        newErrors["start-range"] =  Number(currentSlabValues["start-range"]) <= Number(fieldValues["end-range"]) ? "" : "Start Range should be less than or equal to End Range"
    }

    if( slabUnit?.toLowerCase() === labelMappings["applicable-slab-value"].toLowerCase()){
        if((newErrors["discount-offered"] === undefined || newErrors["discount-offered"] === "") && "discount-offered" in fieldValues && currentSlabValues["end-range"]){
            newErrors["discount-offered"] = Number(fieldValues["discount-offered"]) > Number(currentSlabValues["end-range"]) ? "Discount offered should be less than end range" :"" 
        }

        if("end-range" in fieldValues && currentSlabValues["discount-offered"]){
            newErrors["discount-offered"] = Number(currentSlabValues["discount-offered"]) > Number(fieldValues["end-range"]) ? "Discount offered should be less than end range" :"" 
        }

    }
    
    
    return newErrors

}

/**
 * Checks if current slab values are valid
 * @param errors 
 * @param currentSlabValues 
 * @param fieldsToCheck 
 * @returns 
 */
export const isSlabValid: any = (errors:any , currentSlabValues:any,fieldsToCheck:Record<string,any>) => {
    // this function will check if the form values and return a boolean value
    const res1 = slabsFieldsValidation(errors,currentSlabValues,fieldsToCheck);
    if(res1 !== VALID) return res1;

    const res2 = overlappingRangesInApplicableSlab(currentSlabValues);
    if(res2 !==VALID) return res2;

    return VALID;
}

/**
 * Validation for slab fields
 * @param errors 
 * @param currentSlabValues 
 * @param fieldsToCheck 
 * @returns 
 */

function slabsFieldsValidation(errors: any, currentSlabValues: any, fieldsToCheck: Record<string, any>) {
    const res: boolean = Object.keys(fieldsToCheck).every((field: string) => {
        if(!isSlabFieldRequired(field)) return true;
        return currentSlabValues[field] && currentSlabValues[field] !== ""
    }) && Object.values(errors).every((x) => x === "");
    if (res) return VALID;
    else return INVALID_SLAB_FIELD;
}

/**
 * Checks of any slabs has overrlapping intervals
 * @param currentData 
 * @returns 
 */

const overlappingRangesInApplicableSlab = (currentData: any)=>{
    const {data: slabInfo} = store.getState()?.manageCoupons?.data?.slabInfo;
    for(let i=0 ; i<slabInfo.length ; i++){
        const source = slabInfo[i];
        if(source.id === currentData.id) continue;
        if(source["start-range"] === "" || source["end-range"] === "") continue;
        else if(( source["start-range"] && (Number(source["start-range"]) > Number(currentData["end-range"]))) || ( source["end-range"] && (Number(source["end-range"]) < Number(currentData["start-range"]))) )
            continue;
        else return INVALID_RANGE_OVERLAPPING;
    }
    
    return VALID;
}

/**
 * the text field where the user enter data is stored in redux and this function
 * checks if there is an already existing empty slab
 * @returns 
 */
export const isEmptySlabAlreadyExist = (inputs:any[])=>{
    const { data:slabsData } = store.getState().manageCoupons?.data?.slabInfo;
    for(let i=0 ; i<slabsData.length ; i++){
        const slab = slabsData[i];
        if(slab.isEdit){
            return true;
        }
    }
    return false;
}


/**
 * return all the fields that needs to be validated
 * @param inputs 
 * @returns `{ fieldName -> true }`
 */
export const getFieldsToCheck = (inputs:APPLICABLE_SLABS_INPUTS_types[]):Record<string,boolean>=>{
    const fields:Record<string,boolean> = {};
    inputs.forEach((input:{id:string})=>{
        fields[input.id] = true;
    })
    return fields;
}



/**
 * This function return the fields we want to show in applicable slab UI
 * (eg. in bundle we show final value input field but in rest of coupons we do not show. This function handles this case)
 * APPLICABLE_SLABS_INPUTS : it has all the fields
 *  
 *  @returns 
 */
export const getFilteredSlabInputs = ():APPLICABLE_SLABS_INPUTS_types[]=>{
    const {couponTypeOption} = store.getState()?.manageCoupons?.data;
    const allSlabs = getApplicableSlabsInputs();
    const ans :APPLICABLE_SLABS_INPUTS_types[] = [];
    
    for(let i=0 ; i<allSlabs.length ; i++){
        const item = allSlabs[i];
        if(item.id ==="final-order-value" && couponTypeOption !== COUPON_TYPE_OPTIONS_VALUE.BUNDLE_PLUS_TOTAL_ORDER_VALUE) continue;
        ans.push(item);
    }
    return ans;
}

/**
 * any unsaved values present in redux or not
 * @param inputs array of inputs to check values for
 * @returns boolean
 */
export const isUnsavedSlabPresentInRedux = (inputs?:APPLICABLE_SLABS_INPUTS_types[]):boolean=>{
    const { data:slabsData } = store.getState().manageCoupons?.data?.slabInfo;
    

    const fieldsToCheck  = inputs ? getFieldsToCheck(inputs) :getFieldsToCheck(getFilteredSlabInputs());

    for(let i=0 ; i<slabsData.length ; i++){
        const slab = slabsData[i];
        if(slab.isEdit === true){
            let anyDataPresent = false;
            Object.keys(fieldsToCheck).forEach((field:string)=>{
                if(slab[field]!== null && slab[field]!== undefined && slab[field].trim()!==""){
                    anyDataPresent = true;
                }
            })
            if(anyDataPresent) return true;
        }
    }

    return false;
}

/**
 * any values filled in the slab by the user
 * @param values 
 * @param inputs 
 * @returns boolean
 */
export const anyValueFilled = (values:any , inputs:APPLICABLE_SLABS_INPUTS_types[])=>{
    const fieldsToCheck  = getFieldsToCheck(inputs);

    let anyDataPresent = false;
    Object.keys(fieldsToCheck).forEach((field:string)=>{
        if(values[field]!== null && values[field]!== undefined && values[field].trim()!==""){
            anyDataPresent = true;
        }
    })
    
    return anyDataPresent;
}

/**
 * return an object containg id of the input fields
 */
export const getSlabEmptyTemplate = ()=>{
    const inputs = getFilteredSlabInputs();
    let ans:Record<string,string> = {};

    inputs.forEach((input)=>{
        ans[input.id] = '';
    })
    return ans;
}

/**
 * 
 * @param slab 
 * @param fields 
 * @returns boolean
 */
export const isAllRequiredValueFilled = (slab: Record<string, string>, fields: string[]) => {
    if(!fields || fields.length == 0 ){
        for (const key in slab) {
            if (isSlabFieldRequired(key) && (slab[key] === null || slab[key] === undefined || ( typeof slab[key]=== "string" && slab[key].trim() === ""))) {
                return false;
            }
        }
        return true;
    }

    else {
        for(let i=0 ; i<fields.length ; i++){
            const fieldName = fields[i];
            if(isSlabFieldRequired(fieldName) && ( slab[fieldName] === null || slab[fieldName] === undefined || slab[fieldName].trim()==="")){
                return false;
            }
        }
        return true;
    }
    
}



const saveUnsavedSlabs = ():string=>{
    const { data:slabsData , slabUnit } = store.getState().manageCoupons?.data?.slabInfo;
    const fieldsToCheck  = getFieldsToCheck(getFilteredSlabInputs());

    for(let i=0 ; i<slabsData.length ; i++){
        const slab = slabsData[i];

        const validationErrors = validateSingleSlab(slab,slab,fieldsToCheck,{},true,slabUnit);
        
        const res = isSlabValid(validationErrors,slab,fieldsToCheck);
        if(res === INVALID_SLAB_FIELD) return labelMappings["SLAB_VALIDATION_FAILED"];
        else if( res === INVALID_RANGE_OVERLAPPING) return labelMappings["APPLICABLE_SLAB_RANGE_OVERLAPPING"];

        if(isAllRequiredValueFilled(slab,Object.keys(fieldsToCheck))){
            addApplicableSlab({...slab,isEdit:false},slab.id);
        }
    }

    return ""
}

export const handleApplicableSlabUnsavedData = ():string=>{
    const res = saveUnsavedSlabs();

    if(res.trim() !== "" ){
        return res;
    }

    if(isUnsavedSlabPresentInRedux()){
        return labelMappings["SLAB_MANDATORY_FIELDS_EMPTY"];
    }

    return "";

}


export const isSlabFieldRequired =(fieldId:string):boolean=>{
    
    const field = getApplicableSlabsInputs().filter((item)=>item.id === fieldId);
    if(field.length === 0) return false;

    let required:boolean = false ;
    field[0].components.forEach((comp)=>{
        if(comp.props.name === fieldId){
            required = comp.props.required
        }
    })
    return required;
}